import Axios from '@/utils/axios';
import { storage } from '@/utils/storage';

const AuthService = {
  login: async (firebaseToken: string) => {
    try {
      const data = { token: firebaseToken };
      const response = await Axios.post('/v1/auth/user/login', data);
      const backendToken = response.data.data.token;

      storage.setItem('token', backendToken);

      return backendToken;
    } catch (error: any) {
      throw error;
    }
  },

  // Ask nest-fleet-service whether an email may access the app. The email comes
  // from the completed Google sign-in (before a backend session exists). The
  // allowlist never leaves the server — we only get a boolean back. Throws on
  // network/5xx so the caller can fall back to the cached verdict.
  checkAccess: async (email: string): Promise<boolean> => {
    const response = await Axios.post('/v1/fleet/auth/whitelist/check', {
      email,
    });
    return Boolean(response.data?.data?.allowed);
  },

  logout: () => {
    storage.clear();

    if (window.location.pathname !== '/signin') {
      window.location.href = '/signin';
    }
  },

  getToken: () => {
    return storage.getItem('token');
  },

  isAuthenticated: () => {
    return !!AuthService.getToken();
  },
};

export default AuthService;
